import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { ScenesData } from '@/components/landing/VideoExampleModal';
import { VIDEO_EXAMPLES as FALLBACK_EXAMPLES } from '@/constants/videoExamples';

export interface VideoExample {
  id: string;
  title: string;
  description: string | null;
  video_url: string | null;
  thumbnail_url: string | null;
  prompt_text: string | null;
  duration: string | null;
  display_order: number;
  scenes_data: ScenesData | null;
}

export function useVideoExamples() {
  const [examples, setExamples] = useState<VideoExample[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchExamples = async () => {
      try {
        const { data, error } = await supabase
          .from('video_examples')
          .select('id, title, description, video_url, thumbnail_url, prompt_text, duration, display_order, scenes_data')
          .eq('is_active', true)
          .order('display_order', { ascending: true });

        if (error || !data?.length) {
          console.warn('[useVideoExamples] DB unavailable or empty, using hardcoded fallback');
          setExamples(FALLBACK_EXAMPLES);
          setLoading(false);
          return;
        }

        // Parse scenes_data from JSON
        const parsed = (data || []).map(v => ({
          ...v,
          scenes_data: v.scenes_data as unknown as ScenesData | null
        }));

        setExamples(parsed);
      } catch (err) {
        console.warn('[useVideoExamples] Exception, using fallback:', err);
        setExamples(FALLBACK_EXAMPLES);
      } finally {
        setLoading(false);
      }
    };

    fetchExamples();
  }, []);

  return { examples, loading, error };
}
